import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterSearchingRechazosTracesViewModel, RechazosTracesItemResultsViewModel, RechazosTracesItemViewModel } from '../rechazostraces.types';
import { RechazosTracesService } from '../rechazostraces.service';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { FilterSearchingBaseViewModel, Tc } from '../../../../core/_infrastructure/types/common';

@Component({
    selector: 'app-rechazostraces-wrapper',
    templateUrl: './rechazostraces-wrapper.component.html',
})
export class RechazosTracesWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: RechazosTracesItemResultsViewModel | null;
    payload?: FilterSearchingRechazosTracesViewModel;
    edition = false;

    listPaises: Tc[];

    isRechazo = false;

    activatedRouteData$ = this.activatedRoute.data.subscribe(data => {
        this.isRechazo = data['isRechazo'] === true;
    });

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private rechazosTracesService: RechazosTracesService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.globalService.getAllPaises().subscribe(params => {
            this.listPaises = params;
        });

        this.recoverLastSearch();
    }

    onSearch(payload: FilterSearchingRechazosTracesViewModel): void {
        if (!payload) {
            return;
        }

        this.payload = { ...payload }; // Guardar la copia para los rechazos

        // Determinar el método del servicio basado en 'isRechazo'
        const serviceMethod = this.isRechazo ? 'getRechazosTraces' : 'getTrasladosTraces';

        // Llamar al servicio que corresponsa basado en la condición de 'isRechazo'
        this.rechazosTracesService[serviceMethod](payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        if (!lazyLoadParams) {
            return;
        }

        // Crear el payload dependiendo de si es Rechazo o Traslado
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingRechazosTracesViewModel;

        // Llamar a onSearch con el payload generado
        this.onSearch(payload);
    }

    onReset(): void {
        this.searching = false;
        this.result = null;

        // Llamar al servicio adecuado dependiendo de si es Rechazo o Traslado
        this.isRechazo ? this.rechazosTracesService.clearLastSearch() : this.rechazosTracesService.clearLastSearchTransfer();
    }

    onDetail(item: RechazosTracesItemViewModel | null): void {
        this.edition = true;
        const baseRoute = this.isRechazo ? '/importacion/rechazostraces/partei/' : '/importacion/trasladostraces/partei/';
        this.router.navigate([baseRoute, item?.CHEDPP]);
    }

    private recoverLastSearch() {
        this.isRechazo ? (this.payload = this.rechazosTracesService.getLastSearch()) : (this.payload = this.rechazosTracesService.getLastSearchTransfer());
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;

        const model: FilterSearchingRechazosTracesViewModel = new FilterSearchingRechazosTracesViewModel();
        Object.assign(model, this.payload);

        this.rechazosTracesService.export(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    exportIsAvailable(): boolean {
        return this.result?.ResultList ? this.result?.ResultList?.length > 0 : false;
    }
}
